import React from "react";

const partnerData = [
  {
    id: 1,
    name: "Saint Soldier Public School",
    logo: "./assets/images/reviews/ecerXOxqEVQEL7F919XK.png",
    // description: "Leading provider of sports equipment and technology",
    // category: "Equipment Partner",
  },
  {
    id: 2,
    name: "Bright Future Sr Sec School",
    logo: "./assets/images/reviews/bf.jpg",
    // description: "Premium sports nutrition and supplements",
    // category: "Nutrition Partner",
  },
];

const PartnerCard = ({ partner }) => (
  <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:scale-105">
    <div className="p-6">
      <img
        src={partner.logo}
        alt={`${partner.name} logo`}
        className="w-full h-32 object-contain mb-4"
      />
      <div className="text-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          {partner.name}
        </h3>
        <span className="inline-block bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full mb-3">
          {partner.category}
        </span>
        <p className="text-gray-600">{partner.description}</p>
      </div>
    </div>
  </div>
);

const OurPartners = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Our Academies
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're proud to work with industry-leading partners who share our
            commitment to excellence in sports and athlete development.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partnerData.map((partner) => (
            <PartnerCard key={partner.id} partner={partner} />
          ))}
        </div>

        {/* Call to Action Section */}
        {/* <div className="mt-20 text-center">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Interested in Becoming a Partner?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Join our network of trusted partners and help shape the future of
            sports development. We're always looking for organizations that
            share our values and vision.
          </p>
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-300">
            Contact Us About Partnership
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default OurPartners;
